import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Button, Tooltip } from 'reactstrap';
import { connect } from 'react-redux';
import { getCurrentOfferPaymentOption } from 'modules/checkout/selectors';

let collectJsConfigured = false;

const EasyPayDirect = props => {
  const [easyPayLoaded, setEasyPayLoaded] = useState(false);
  const [easyPayToolTipOpen, setEasyPayToolTipOpen] = useState(false);

  useEffect(() => {
    if (window.CollectJS) {
      setEasyPayLoaded(true);
      return;
    }

    console.log('no window.collectjs');

    const existingScript = document.querySelector(
      'script[src="https://secure.easypaydirectgateway.com/token/Collect.js"]'
    );

    if (existingScript) {
      existingScript.addEventListener('load', () => setEasyPayLoaded(true));
      return;
    }

    // CollectJS injects Apple's Apple Pay SDK (applepay.cdn-apple.com) from its constructor,
    // which defines window.ApplePaySession globally and breaks Braintree's Apple Pay.
    // Block that specific script by intercepting appendChild while CollectJS loads.
    const originalAppendChild = document.head.appendChild.bind(document.head);
    document.head.appendChild = function (node) {
      if (node.src && node.src.includes('applepay.cdn-apple.com')) return node;
      return originalAppendChild(node);
    };

    const easyPayScript = document.createElement('script');
    easyPayScript.src = 'https://secure.easypaydirectgateway.com/token/Collect.js';
    easyPayScript.setAttribute('data-tokenization-key', process.env.EASYPAY_TOKENIZATION_KEY);
    easyPayScript.addEventListener('load', () => {
      document.head.appendChild = originalAppendChild;
      console.log('easyPay loaded for lightbox');
      setEasyPayLoaded(true);
    });
    document.body.appendChild(easyPayScript);
  }, []);

  const prettyBrandName = {
    visa: 'Visa',
    mastercard: 'Mastercard',
    discover: 'Discover',
    amex: 'American Express',
    diners: "Diner's Club", // you know all those Diner's Club HSA cards, right?
    jcb: 'JCB',
    maestro: 'Maestro'
  };

  useEffect(() => {
    if (easyPayLoaded && !collectJsConfigured) {
      collectJsConfigured = true;
      // Braintree handles Apple Pay — prevent CollectJS from touching it.
      // Must be set BEFORE configure() because tokenPromise may already be resolved,
      // causing buildApplePayButton to fire as a microtask before the next line runs.
      window.CollectJS.buildApplePayButton = async () => {};
      window.CollectJS.configure({
        variant: 'lightbox',
        buttonText: 'Continue',
        callback: payload => {
          // map the card type, if it exists, to a more user-friendly name
          if (payload && payload.card && payload.card.type) {
            payload.card.type = prettyBrandName[payload.card.type];
          }
          props.setPaymentToken({ gateway: 'easyPay', token: payload });
        }
      });
    }
  }, [easyPayLoaded]);

  const currentOfferPaymentOption = props.currentOfferPaymentOption;
  const buttonDisabled = currentOfferPaymentOption ? currentOfferPaymentOption.numInstallments > 1 : false;

  return (
    <div style={{ height: '50px' }}>
      <div className="d-flex align-items-center">
        <span style={{ width: '100%', maxWidth: '280px' }} className="m-auto text-center">
          <span id="Easy-Pay-Payment-Method" style={{ display: 'block', width: '100%' }}>
            <Button
              onClick={() => {
                window.CollectJS.startPaymentRequest();
              }}
              style={{
                width: '100%',
                height: '45px',
                lineHeight: '1.1',
                ...(buttonDisabled ? { pointerEvents: 'none' } : {})
              }}
              className="d-flex justify-content-center align-items-center"
              color="dark"
              disabled={buttonDisabled}
            >
              <span className="pr-3">Buy with HSA or FSA Card</span>
            </Button>
          </span>
          {buttonDisabled && (
            <Tooltip
              placement="right"
              target="Easy-Pay-Payment-Method"
              isOpen={easyPayToolTipOpen}
              toggle={() => setEasyPayToolTipOpen(!easyPayToolTipOpen)}
              trigger="click hover focus"
            >
              HSA/FSA does not support payment plans. Please choose a different Payment option.
            </Tooltip>
          )}
        </span>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  currentOfferPaymentOption: getCurrentOfferPaymentOption(state)
});
export default connect(mapStateToProps, null)(EasyPayDirect);
